import { render, staticRenderFns } from "./EntryOwners.vue?vue&type=template&id=594cb319&scoped=true"
import script from "./EntryOwners.vue?vue&type=script&lang=js"
export * from "./EntryOwners.vue?vue&type=script&lang=js"
import style0 from "./EntryOwners.vue?vue&type=style&index=0&id=594cb319&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594cb319",
  null
  
)

export default component.exports